import { render, staticRenderFns } from "./Cobrancas.vue?vue&type=template&id=78c95624&scoped=true"
import script from "./Cobrancas.vue?vue&type=script&lang=js"
export * from "./Cobrancas.vue?vue&type=script&lang=js"
import style0 from "./Cobrancas.vue?vue&type=style&index=0&id=78c95624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c95624",
  null
  
)

export default component.exports